
import axios from '../../http/config'
//初始化数据
const state = {
    adList: [1,2]
}

//getter 抛出去的数据
const getters = {
    //广告列表
    adList:state =>state.adList
}

//action 异步的操作
const actions = {
    adListFn({commit}){
      axios.get(`/outer/image/listImages.do`, {
        functionCode:2
      }).then((res)=>{
        commit('adListm',res.data);
      })
    }
}

//mutation
const mutations = {
    adListm(state,data){
      state.adList = data
    }
}


export default {
    state,
    mutations,
    actions,
    getters,
  };



// WEBPACK FOOTER //
// ./src/store/modules/ad.js